module.exports = __webpack_public_path__ + "front-end-tools.31oaOESI.svg";